import {useNavigate} from 'react-router-dom'
import {useTranslation} from 'react-i18next'
import {Button} from '@/components/ui/button'
import {Dialog, DialogContent, DialogHeader, DialogTitle} from '@/components/ui/dialog'
import {usePlanPropuesta} from '@/hooks/sgsst/plan/use-plan-propuesta'

/** plan-propuesta-spec §4: dismissable, and absent when there is nothing to propose. */
export function PlanPropuestaInterstitial({
  businessId,
  year,
  open,
  onDismiss,
}: {
  businessId: string
  year: number
  open: boolean
  onDismiss: () => void
}) {
  const {t} = useTranslation()
  const navigate = useNavigate()
  const {data} = usePlanPropuesta(open ? businessId : undefined)
  const total = data?.total ?? 0
  return (
    <Dialog open={open && total > 0} onOpenChange={(next) => !next && onDismiss()}>
      <DialogContent data-testid="propuesta-interstitial">
        <DialogHeader>
          <DialogTitle>{t('plan.propuesta.interstitialTitle', {year})}</DialogTitle>
        </DialogHeader>
        <p className="text-sm text-muted-foreground">{t('plan.propuesta.interstitialBody', {count: total})}</p>
        <div className="flex justify-end gap-2">
          <Button variant="outline" onClick={onDismiss} data-testid="propuesta-interstitial-dismiss">
            {t('plan.propuesta.interstitialDismiss')}
          </Button>
          <Button
            onClick={() => navigate(`/businesses/${businessId}/sgsst/plan/propuesta`)}
            data-testid="propuesta-interstitial-review">
            {t('plan.propuesta.interstitialReview')}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  )
}
